import { render, staticRenderFns } from "./CourseFiles.vue?vue&type=template&id=1f2ded34&scoped=true"
import script from "./CourseFiles.vue?vue&type=script&lang=js"
export * from "./CourseFiles.vue?vue&type=script&lang=js"
import style0 from "./CourseFiles.vue?vue&type=style&index=0&id=1f2ded34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ded34",
  null
  
)

export default component.exports